import { useMutation } from '@apollo/client'
import {
  GET_CELEBRATION_LEVEL_GROUP_STATUS,
  GET_PROGRAM_OFFSETS_BY_PROGRAM_ID,
} from '../graphql'

interface ybPatchCelebrationLevelGroupConfigsV2 {
  config: {
    suspended?: boolean
    id: string
  }
  programId: string
}

export interface YbCelebrationLevelGroupConfigUpdateInputV2 {
  result: {
    suspended?: boolean
    message?: string
    status: string
  }[]
}

interface resumeGroupActionParams {
  input: ybPatchCelebrationLevelGroupConfigsV2
  onSuccess?: () => void
  onError?: (error: Error) => void
}

const useCelebrationLevelGroupStatus = () => {
  const [mutate, { loading, error }] = useMutation<
    {
      ybPatchCelebrationLevelGroupConfigsV2: YbCelebrationLevelGroupConfigUpdateInputV2
    },
    { input: ybPatchCelebrationLevelGroupConfigsV2 }
  >(GET_CELEBRATION_LEVEL_GROUP_STATUS)
  const updateSuspendGroupAction = async ({
    input,
    onSuccess,
    onError,
  }: resumeGroupActionParams) => {
    try {
      const { data, errors } = await mutate({
        variables: {
          input,
        },
        errorPolicy: 'all',
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GET_PROGRAM_OFFSETS_BY_PROGRAM_ID,
            variables: {
              programId: input.programId,
            },
            errorPolicy: 'all',
          },
        ],
      })
      if (data && onSuccess) onSuccess()

      let errMsg = ''
      errors?.forEach((error) => {
        const splitMsg = error.message.split('The errors are:')
        errMsg.length > 0
          ? (errMsg += ', ' + splitMsg[1])
          : (errMsg += splitMsg[1])
      })

      if (errors) throw new Error(errMsg)
    } catch (err) {
      if (onError) onError(err)
    }
  }
  return { updateSuspendGroupAction, loading, error }
}

export default useCelebrationLevelGroupStatus
